import { fetchCountries } from 'api/Countries/actions'
import { fetchOwners } from 'api/Owners/actions'
import { ChannelSummary } from 'ChannelSummary'
import classNames from 'classnames'
import { CountriesList } from 'CountriesList'
import { selectChannelsType, selectOwnersList, selectTabRequestParams } from 'data/selectors'
import { ListDetails } from 'ListDetails'
import { selectIsListDetailsOpen } from 'ListDetails/selectors'
import { LoadingOverlay } from 'LoadingOverlay'
import React, { memo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectLastReFetchTime } from 'store/reducers/lastReFetchTime'

import Box from '@mui/material/Box'

import useStyles from './useStyles'

function OwnersList() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { isLoading, list } = useSelector(selectOwnersList())
  const channelsType = useSelector(selectChannelsType)
  const lastReFetchTime = useSelector(selectLastReFetchTime)
  const tabRequestParams = useSelector(selectTabRequestParams)
  const isToggled = useSelector(selectIsListDetailsOpen)
  const showSkeletonLoader = list.length === 0 && isLoading
  const isActive = channelsType === 'owners'

  useEffect(() => {
    if (isActive) dispatch(fetchOwners(tabRequestParams))
  }, [isActive, lastReFetchTime, tabRequestParams, dispatch])

  return (
    <LoadingOverlay isLoading={showSkeletonLoader} shouldHide={!isActive}>
      <Box minHeight={showSkeletonLoader ? '6rem' : '0'}>
        {list.map(data => {
          const { owner } = data
          const fetchList = () => dispatch(fetchCountries({ ...tabRequestParams, owner }))

          return (
            <ChannelSummary
              key={owner}
              className={classNames({ [classes.details]: isToggled })}
              data={data}
              fetchList={fetchList}
              isLoading={isLoading}
              label={owner}
              owner={owner}
              type="owners"
            >
              <ListDetails owner={owner} data={data} isLoading={isLoading} type="owners" />
              {!isToggled && <CountriesList owner={owner} />}
            </ChannelSummary>
          )
        })}
      </Box>
    </LoadingOverlay>
  )
}

export default memo(OwnersList)
